import React from 'react';
import { Fade, Zoom } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';

const ProductSection = () => {
  const projects = [
     {
      id: 3,
      title: 'Corporate Office Interior',
      category: 'Commercial Interior',
      image: '/img/img52.jpg',
      description:
        'A contemporary office interior focused on productivity, brand identity, and modern workspace design.'
    },
    {
    id: 1,
    title: 'Corporate Office Workspace',
    category: 'Office Interior & Fit-Out',
    image: '/img/img51.jpg',
    description:
      'A professionally designed office workspace with smart layouts, premium finishes, and efficient fit-outs that enhance productivity and brand identity.'
  },
    {
    id: 3,
    title: 'Executive Office Interior',
    category: 'Corporate Interior Design',
    image: '/img/img50.jpg',
    description:
      'An executive office interior combining modern design, comfort, and precision execution to create a professional and inspiring environment.'
  },
   
  ];

  return (
    <div className="container-xxl bg-light my-6 py-6 pt-0">
      <div className="container">
        
        {/* Highlight Section */}
        <Fade triggerOnce>
          <div className="bg-call text-light rounded p-5 my-6 mt-0">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-4 text-light mb-0">
                Transforming Spaces Into Experiences
              </h1>
            </div>
            <div className="col-lg-6 text-lg-end">
              <div className="d-inline-flex align-items-center text-start">
                <i className="fa fa-phone-alt fa-4x flex-shrink-0"></i>
                <div className="ms-4">
                  <p className="fs-5 fw-bold mb-0">Call Us</p>
                  <p className="fs-1 fw-bold mb-0">+971 563252389</p>
                </div>
              </div>
            </div>
          </div>
          </div>
        </Fade>

        {/* Section Heading */}
        <Fade triggerOnce>
          <div className="text-center mx-auto mb-5" style={{ maxWidth: '500px' }}>
            <p className="text-primarys text-uppercase mb-2">// Our Works</p>
            <h1 className="display-6 mb-4">
              Explore Our Interior Design Projects
            </h1>
          </div>
        </Fade>

        {/* Portfolio Cards */}
        <div className="row g-4">
          {projects.map((project, index) => (
            <div key={project.id} className="col-lg-4 col-md-6">
              <Zoom delay={100 + index * 200} triggerOnce>
              <div className="product-item d-flex flex-column bg-white rounded overflow-hidden h-100">
                <div className="text-center p-4">
                  <div className="d-inline-block border border-primary rounded-pill px-3 mb-3">
                    {project.category}
                  </div>
                  <h3 className="mb-3">{project.title}</h3>
                  <span>{project.description}</span>
                </div>

                <div className="position-relative mt-auto">
                  <img
                    className="img-fluid"
                    src={project.image}
                    alt={project.title}
                  />
                  <div className="product-overlay">
                    <Link
                      to="/portfolio"
                      className="btn btn-lg-square btn-outline-light rounded-circle"
                    >
                      <i className="fa fa-eye text-primary"></i>
                    </Link>
                  </div>
                </div>
              </div>
              </Zoom>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ProductSection;





